module.exports = __webpack_public_path__ + "media/images/prev-icon-d81e23e4.svg";